module.exports = __webpack_public_path__ + "static/media/progman_30.400ff724.ico";